import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import classes from './MisMentorias.module.css';
import { getDate } from '../../../helpers/functions.helper';

export const Solicitadas = ({solicitadas = [], handleClick}) => {

    const handleAccept = (mentoria) => {
        handleClick({
            estatus: 2,
            text: 'Aceptar',
            mentoria: mentoria
        })
    }

    const handleDecline = (mentoria) => {
        handleClick({
            estatus: 4,
            text: 'Declinar',
            mentoria: mentoria
        })
    }

    return(
        <Container>
            <Row>
                <Col>
                    <Container className={classes.table}>
                        <Row className={classes.thead}>
                            <Col md="1"><span>Folio</span></Col>
                            <Col md="3"><span>Estudiante</span></Col>
                            <Col md="2"><span>Campus</span></Col>
                            <Col md="2"><span>Nivel</span></Col>
                            <Col md="3"><span>Categoría</span></Col>
                            <Col md="2"><span>Fecha</span></Col>
                        </Row>
                        {
                            solicitadas.map((item,index) => (
                                <Row id="row" className={classes.tbody}>
                                    <Col md="1"><span>{item.iFolio}</span></Col>
                                    <Col md="3"><span>{item.sNombreAlumno}</span></Col>
                                    <Col md="2"><span>{item.sCampus}</span></Col>
                                    <Col md="2"><span>{item.sNivel}</span></Col>
                                    <Col md="3"><span>{item.sCategoria}</span></Col>
                                    <Col md="2"><span>{getDate(item.dFecha)}</span></Col>
                                    <Col md="2" className={classes.buttons}>
                                        <div>
                                            <span onClick={()=>{handleAccept(item)}}>Aceptar</span>
                                            |
                                            <span onClick={()=>{handleDecline(item)}}>Declinar</span>
                                        </div>
                                    </Col>
                                </Row>
                            ))
                        }
                    </Container>
                </Col>
            </Row>
        </Container>
    )
}

export const Activas = ({activas = [], handleClick}) => {

    const handleTerminar = (mentoria) => {
        handleClick({
            estatus: 3,
            text: 'Finalizar',
            mentoria: mentoria
        })
    }

    const handleSuspender = (mentoria) => {
        handleClick({
            estatus: 5,
            text: 'Finalizar',
            mentoria: mentoria
        })
    }

    return(
        <Container>
            <Row>
                <Col>
                    <Container className={classes.table}>
                        <Row className={classes.thead}>
                            <Col md="1"><span>Folio</span></Col>
                            <Col md="3"><span>Estudiante</span></Col>
                            <Col md="2"><span>Campus</span></Col>
                            <Col md="2"><span>Nivel</span></Col>
                            <Col md="3"><span>Categoría</span></Col>
                        </Row>
                        {
                            activas.map((item,index) => (
                                <Row id="row" className={classes.tbody}>
                                    <Col md="1"><span>{item.iFolio}</span></Col>
                                    <Col md="3"><span>{item.sNombreAlumno}</span></Col>
                                    <Col md="2"><span>{item.sCampus}</span></Col>
                                    <Col md="2"><span>{item.sNivel}</span></Col>
                                    <Col md="3"><span>{item.sCategoria}</span></Col>
                                    <Col md="4" className={classes.buttons}>
                                        <div>
                                            <span onClick={()=>{handleTerminar(item)}}>Terminar</span>
                                            |
                                            <span onClick={()=>{handleSuspender(item)}}>Suspender por un problema</span>
                                        </div>
                                    </Col>
                                </Row>
                            ))
                        }
                    </Container>
                </Col>
            </Row>
        </Container>
    )
}

export const Finalizadas = ({finalizadas = [], handleClick}) => {
    return(
        <Container>
            <Row>
                <Col>
                    <Container className={classes.table}>
                        <Row className={classes.thead}>
                            <Col md="1"><span>Folio</span></Col>
                            <Col md="3"><span>Estudiante</span></Col>
                            <Col md="2"><span>Campus</span></Col>
                            <Col md="2"><span>Nivel</span></Col>
                            <Col md="3"><span>Categoría</span></Col>
                            <Col md="2"><span>Fecha</span></Col>
                            <Col md="2"><span>Estatus</span></Col>
                        </Row>
                        {
                            finalizadas.map((item,index) => (
                                <Row id="row" className={classes.tbody}>
                                    <Col md="1"><span>{item.iFolio}</span></Col>
                                    <Col md="3"><span>{item.sNombreAlumno}</span></Col>
                                    <Col md="2"><span>{item.sCampus}</span></Col>
                                    <Col md="2"><span>{item.sNivel}</span></Col>
                                    <Col md="3"><span>{item.sCategoria}</span></Col>
                                    <Col md="2"><span>{getDate(item.dFecha)}</span></Col>
                                    <Col md="2"><span>{item.sStatus}</span></Col>
                                </Row>
                            ))
                        }
                    </Container>
                </Col>
            </Row>
        </Container>
    )
}